import React, { Fragment } from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../constants/forms";
import { getFieldProps } from "../../../../utils/form-fields";

import RadioGroup from "../../../controls/RadioGroup";
import CategorySelect from "./CategorySelect";
import StyledButton from "../../../styled/StyledButton";
import TextInput from "../../../controls/TextInput";

const getTextFromBrackets = (textFragment) => {
  const result = textFragment?.match(/\{([^)]+)\}/);
  return result ? result[1] : "";
};

const StyledRow = styled(Row)`
  button {
    width: auto !important;

    &.remove-owner-button {
      margin-left: 16px;
      background: #FFFFFF;
      border: 1px solid #C61F0C;
      color: #C61F0C;

      &:hover {
        background: #C61F0C;
        color: #FFFFFF;
      }
    }
  }
`;

function TrademarkClassInfoBlock({ values = {}, onChange, onAddClass, onRemoveClass }) {
  const isAddDisabled = values?.classes?.some((item) => item.clazz === null);
  return (
    <StyledRow>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Choose Your Trademark Class</span>
        </div>
      </Col>
      <Col xs={12}>
        <div className="input-title">
          <strong>
            Start describing the goods and services related to your mark. Trademark Genius compares the description you
            provide and automatically provides descriptions from the USPTO ID Manual for your consideration.
          </strong>
        </div>
      </Col>
      {values?.classes?.map((classValues, idx) => (
        <Fragment key={`classes${idx}`}>
          <Col xs={12}>
            <div className="input-title-divider" />
          </Col>
          <Col xs={12}>
            <div className="input-title">
              <span>
                Do you sell, or intend to sell, a goods or service?
              </span>
            </div>
          </Col>
          <Col xs={12}>
            <RadioGroup
              horizontal
              {...getFieldProps(FORM_FIELD_KEYS.goods)}
              name={`classes${idx}.${FORM_FIELD_KEYS.goods}`}
              value={classValues[FORM_FIELD_KEYS.goods]}
              onChange={onChange}
            />
          </Col>
          <Col xs={12}>
            <div className="input-title-divider" />
          </Col>
          <Col xs={12}>
            <div className="input-title">
              <strong>
                {classValues[FORM_FIELD_KEYS.goods] === "true" ? "GOODS" : "SERVICES"} 
                &nbsp;-&nbsp;
                Which of these categories best describes the industry or way in which you will use your mark?
              </strong>
            </div>
          </Col>
          <Col xs={12}>
            <div className="input-title">
              <span>
                A specialist will reach out to you if they find that there is a better suiting category.
              </span>
            </div>
          </Col>
          <Col xs={12}>
            <CategorySelect
              {...getFieldProps(FORM_FIELD_KEYS.goodsCategory)}
              id={`classes${idx}.${FORM_FIELD_KEYS.goodsCategory}`}
              validated={values.validated}
              goods={classValues[FORM_FIELD_KEYS.goods]}
              value={classValues[FORM_FIELD_KEYS.goodsCategory]}
              onChange={onChange}
            />
          </Col>
          {classValues[FORM_FIELD_KEYS.goodsCategory]?.includes("{") && (
            <>
              <Col xs={12}>
                <div className="input-title">
                  <span>
                    Please {getTextFromBrackets(classValues[FORM_FIELD_KEYS.goodsCategory])}
                  </span>
                </div>
              </Col>
              <Col xs={12}>
                <TextInput
                  {...getFieldProps(FORM_FIELD_KEYS.description)}
                  id={`classes${idx}.${FORM_FIELD_KEYS.description}`}
                  value={classValues[FORM_FIELD_KEYS.description]}
                  onChange={onChange}
                />
              </Col>
            </>
          )}
          <Col xs={12} className="d-flex justify-content-end">
            <StyledButton
              small
              secondary
              onClick={onAddClass}
              disabled={isAddDisabled}
            >
              <span>+ Add Class</span>
            </StyledButton>
            {values?.classes?.length > 1 && (
              <StyledButton
                small
                secondary
                className="remove-owner-button"
                onClick={onRemoveClass(idx)}
              >
                <span>- Remove Class</span>
              </StyledButton>
            )}
          </Col>
        </Fragment>
      ))}
      <Col xs={12}>
        <div className="input-title">
          <span>
            ***Please note, a separate USPTO filing fee of $450 applies per class of goods/services.
          </span>
        </div>
      </Col>
    </StyledRow>
  );
}

export default TrademarkClassInfoBlock;
